import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot", { email });
      setSent(true);
    } catch (err) {
      setError(formatError(err));
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0] px-4">
      <div className="w-full max-w-md bg-white border border-[#DCD8D0] rounded-xl p-8 space-y-4">
        <h1 className="font-display text-2xl font-bold text-[#1A1A1A]">He olvidado la contraseña</h1>
        {sent ? (
          <p className="text-[#5C5C5C]" data-testid="forgot-sent">
            Si ese correo tiene acceso al panel, te hemos enviado un enlace para cambiar la contraseña. Vale 60 minutos.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label htmlFor="fg-email">Correo</Label>
              <Input id="fg-email" type="email" required className="mt-1 bg-[#F7F5F0] border-[#DCD8D0]" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            {error && <p className="text-sm text-acento">{error}</p>}
            <Button type="submit" className="w-full bg-marca hover:bg-marca-hover text-white" data-testid="forgot-send">Enviar enlace</Button>
          </form>
        )}
        <Link to="/admin/login" className="text-sm underline">Volver a entrar</Link>
      </div>
    </div>
  );
}
